/* ==========================================================================
   SAMDIYA — Custom JavaScript Engine (Homepage & Product Page)
   Hero Slider Autoplay & Controls, Wishlist LocalStorage, Pincode Estimator
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  /* Intercept Add to Cart / Buy Now to trigger the native cart drawer */
  const samdiyaProductForm = document.getElementById('samdiya-product-form');

  if (samdiyaProductForm) {
    samdiyaProductForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(samdiyaProductForm);
      const submitter = e.submitter; // which button was actually clicked
      const isBuyNow = submitter && submitter.classList.contains('samdiya-buy-now-btn');

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        if (isBuyNow) {
          // Buy It Now still goes straight to checkout, skipping the drawer
          window.location.href = '/checkout';
          return;
        }

        // Refresh the cart drawer's contents via Shopify's Section Rendering API
        fetch('/?section_id=cart-drawer-section')
          .then(function (res) { return res.text(); })
          .then(function (html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawerSection = doc.getElementById('shopify-section-cart-drawer-section');
            const currentDrawerSection = document.getElementById('shopify-section-cart-drawer-section');

            if (newDrawerSection && currentDrawerSection) {
              currentDrawerSection.innerHTML = newDrawerSection.innerHTML;
            }

            // Open the native Horizon cart drawer
            const cartDrawer = document.getElementById('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          });
      })
      .catch(function (error) {
        console.error('[SAMDIYA] Add to cart error:', error);
      });
    });
  }



  /* 15. Mobile drawer accordion for nested menu items */
  document.querySelectorAll('.samdiya-drawer-accordion-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.samdiya-drawer-accordion');
      item.classList.toggle('is-open');
    });
  });

  /* 16. Desktop mega-menu — JS-controlled hover (bypasses CSS :hover reliability issues) */
  document.querySelectorAll('.samdiya-nav-links-list li.has-dropdown').forEach(function (item) {
    let closeTimer;
    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      item.classList.add('is-open');
    });
    item.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        item.classList.remove('is-open');
      }, 150);
    });
  });

  /* Notify Me Form Success State */
const notifyForm = document.getElementById('samdiya-notify-form');
if (notifyForm) {
  notifyForm.addEventListener('submit', function () {
    setTimeout(function () {
      const successMsg = document.getElementById('samdiya-notify-success');
      if (successMsg) {
        notifyForm.style.display = 'none';
        successMsg.style.display = 'block';
      }
    }, 300);
  });
}

  /* Mobile Drawer Menu Toggle */
const menuToggleBtn = document.getElementById('samdiya-menu-toggle');
const mobileDrawer = document.getElementById('samdiya-mobile-drawer');
const drawerOverlay = document.getElementById('samdiya-drawer-overlay');
const drawerCloseBtn = document.getElementById('samdiya-drawer-close');

function openMobileDrawer() {
  mobileDrawer.classList.add('is-open');
  drawerOverlay.classList.add('is-open');
  document.body.style.overflow = 'hidden';
}
function closeMobileDrawer() {
  mobileDrawer.classList.remove('is-open');
  drawerOverlay.classList.remove('is-open');
  document.body.style.overflow = '';
}
if (menuToggleBtn) menuToggleBtn.addEventListener('click', openMobileDrawer);
if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeMobileDrawer);
if (drawerOverlay) drawerOverlay.addEventListener('click', closeMobileDrawer);

  /* 1. Full Wishlist Engine (Cards, PDP & Wishlist Page Grid) */
  function getWishlistProducts() {
    try {
      const stored = localStorage.getItem('samdiya_wishlist_products');
      return stored ? JSON.parse(stored) : [];
    } catch(e) {
      return [];
    }
  }

  function saveWishlistProducts(items) {
    localStorage.setItem('samdiya_wishlist_products', JSON.stringify(items));
    updateWishlistUI();
  }

  function updateWishlistUI() {
    const items = getWishlistProducts();
    const count = items.length;

    // 1. Update header wishlist badge count across the site
    document.querySelectorAll('.samdiya-wishlist-count-badge, #samdiya-wishlist-count').forEach(badge => {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });

    // 2. Sync active heart states on product cards & PDP buttons
    document.querySelectorAll('.samdiya-wishlist-btn, .samdiya-wishlist-pdp-btn').forEach(btn => {
      const pId = btn.getAttribute('data-product-id');
      const isWishlisted = items.some(item => String(item.id) === String(pId));

      if (isWishlisted) {
        btn.classList.add('active');
        const textSpan = btn.querySelector('.wishlist-text-label');
        if (textSpan) textSpan.textContent = '♥ Added to Wishlist';
      } else {
        btn.classList.remove('active');
        const textSpan = btn.querySelector('.wishlist-text-label');
        if (textSpan) textSpan.textContent = 'Add to Wishlist';
      }
    });

    // 3. Render Wishlist Page Grid if on Wishlist Page
    renderWishlistPageGrid();
  }

  function toggleWishlistProduct(productData) {
    let items = getWishlistProducts();
    const index = items.findIndex(item => String(item.id) === String(productData.id));
    let isAdded = false;

    if (index > -1) {
      items.splice(index, 1);
      showToast(`Removed "${productData.title || 'Product'}" from your Wishlist`);
    } else {
      items.push(productData);
      isAdded = true;
      showToast(`❤️ Added "${productData.title || 'Product'}" to your Wishlist!`);
    }

    saveWishlistProducts(items);
    return isAdded;
  }

  function extractProductDataFromElement(btn) {
    const pId = btn.getAttribute('data-product-id') || 'prod-' + Math.floor(Math.random() * 10000);
    const card = btn.closest('.samdiya-card, .samdiya-buy-box, .product-card, .resource-card');

    let title = btn.getAttribute('data-product-title');
    let price = btn.getAttribute('data-product-price');
    let image = btn.getAttribute('data-product-img');
    let vendor = btn.getAttribute('data-product-vendor');
    let url = btn.getAttribute('data-product-url');

    if (!title && card) {
      const tElem = card.querySelector('.samdiya-card-title, .samdiya-buy-box-title, h3, h1, .product-card__title');
      if (tElem) title = tElem.textContent.trim();
    }
    if (!price && card) {
      const pElem = card.querySelector('.price, .samdiya-current-price');
      if (pElem) price = pElem.textContent.trim();
    }
    if (!image && card) {
      const iElem = card.querySelector('img');
      if (iElem) image = iElem.src;
    }
    if (!vendor && card) {
      const vElem = card.querySelector('.samdiya-card-vendor, .samdiya-buy-box-vendor');
      if (vElem) vendor = vElem.textContent.trim();
    }
    if (!url && card) {
      const aElem = card.querySelector('a');
      if (aElem) url = aElem.getAttribute('href');
    }

    return {
      id: pId,
      title: title || 'Luxury Product',
      vendor: vendor || 'SAMDIYA',
      price: price || 'Rs. 2,999.00',
      image: image || 'https://images.unsplash.com/photo-1581783342308-f792dbdd27c5?q=80&w=600',
      url: url || 'preview-product.html'
    };
  }

  // Wishlist Button Click Delegate for Card Hearts & PDP Button
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.samdiya-wishlist-btn, .samdiya-wishlist-pdp-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const pData = extractProductDataFromElement(btn);
    toggleWishlistProduct(pData);
  });

  // Render Wishlist Page Container
  function renderWishlistPageGrid() {
    const gridElem = document.getElementById('samdiya-wishlist-grid-container');
    const emptyElem = document.getElementById('samdiya-wishlist-empty-container');
    const countHeading = document.getElementById('samdiya-wishlist-count-heading');

    if (!gridElem && !emptyElem) return;

    const items = getWishlistProducts();

    if (countHeading) {
      countHeading.textContent = `(${items.length} ${items.length === 1 ? 'Item' : 'Items'})`;
    }

    if (items.length === 0) {
      if (gridElem) gridElem.style.display = 'none';
      if (emptyElem) emptyElem.style.display = 'block';
    } else {
      if (emptyElem) emptyElem.style.display = 'none';
      if (gridElem) {
        gridElem.style.display = 'grid';
        gridElem.innerHTML = items.map(product => `
          <div class="samdiya-card samdiya-product-card" data-product-id="${product.id}">
            <div class="samdiya-card-media">
              <button class="samdiya-wishlist-remove-btn" onclick="removeWishlistItem('${product.id}')" title="Remove from Wishlist">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
              <div style="position: absolute; top: 12px; left: 12px; z-index: 5;">
                <span class="samdiya-badge samdiya-badge-new">NEW</span>
              </div>
              <a href="${product.url}"><img src="${product.image}" alt="${product.title}" class="primary-img"></a>
              <div class="samdiya-quick-add-wrap">
                <button type="button" class="samdiya-quick-add-btn">+ Quick Add</button>
              </div>
            </div>
            <div class="samdiya-product-info">
              <div>
                <div class="samdiya-card-sub-header">
                  <span class="samdiya-card-vendor">${product.vendor || 'SAMDIYA'}</span>
                  <span class="samdiya-card-stars">★★★★★</span>
                </div>
                <h3 class="samdiya-card-title"><a href="${product.url}">${product.title}</a></h3>
              </div>
              <div class="samdiya-card-price-row">
                <span class="price">${product.price}</span>
              </div>
            </div>
          </div>
        `).join('');
      }
    }
  }

  window.removeWishlistItem = function(pId) {
    let items = getWishlistProducts();
    const target = items.find(i => String(i.id) === String(pId));
    items = items.filter(i => String(i.id) !== String(pId));
    saveWishlistProducts(items);
    if (target) {
      showToast(`Removed "${target.title}" from your Wishlist`);
    }
  };

  // Sync initial state on load
  updateWishlistUI();

  /* 1b. Universal Quick Add Delegated Handler Across All Website Product Cards */
  function showToast(message) {
    let toast = document.getElementById('samdiya-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'samdiya-toast';
      toast.style.cssText = 'position:fixed; bottom:24px; right:24px; background:#1E1E1E; color:#FFF; padding:12px 22px; border-radius:30px; font-size:0.88rem; font-weight:600; z-index:9999; box-shadow:0 10px 30px rgba(0,0,0,0.2); transition:all 0.3s ease; opacity:0; transform:translateY(20px); pointer-events:none; display:flex; align-items:center; gap:8px;';
      document.body.appendChild(toast);
    }
    toast.innerHTML = `<span style="font-size:1.1rem;">🛒</span> <span>${message}</span>`;
    toast.style.opacity = '1';
    toast.style.transform = 'translateY(0)';

    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(20px)';
    }, 2800);
  }

  function updateGlobalCartCount(newCount) {
    const badges = document.querySelectorAll('.cart-badge-count, #samdiya-cart-count, .samdiya-header-cart-badge, .cart-icon-bubble');
    badges.forEach(badge => {
      let current = parseInt(badge.textContent || '0');
      let count = typeof newCount === 'number' ? newCount : current + 1;
      badge.textContent = count;
      badge.style.transform = 'scale(1.3)';
      setTimeout(() => badge.style.transform = 'scale(1)', 200);
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.samdiya-quick-add-btn, .quick-add__button--add, button[name="add"].add-to-cart-button');
    if (!btn) return;

    const form = btn.closest('form');
    const card = btn.closest('.samdiya-card, product-card, .product-grid__card, .product-grid__item, .resource-card');
    const titleElem = card ? card.querySelector('.samdiya-card-title, .product-card__title, h3, h4, a') : null;
    const title = titleElem ? titleElem.textContent.trim() : 'Product';

    if (form) {
      e.preventDefault();
      e.stopPropagation();

      const formData = new FormData(form);
      const originalText = btn.innerHTML;
      btn.innerHTML = '✓ Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(data => {
        btn.innerHTML = '✓ Added!';
        btn.style.background = '#3D4F40';
        showToast(`Added "${title}" to your cart!`);
        updateGlobalCartCount();

        // Trigger theme cart drawer if present
        const cartDrawer = document.querySelector('cart-drawer-component, #samdiya-cart-drawer-btn');
        if (cartDrawer && cartDrawer.click) {
          setTimeout(() => cartDrawer.click(), 300);
        }

        setTimeout(() => {
          btn.innerHTML = originalText;
          btn.style.background = '#1E1E1E';
          btn.disabled = false;
        }, 2000);
      })
      .catch(err => {
        console.log('AJAX cart add fallback', err);
        btn.innerHTML = '✓ Added!';
        btn.style.background = '#3D4F40';
        showToast(`Added "${title}" to your cart!`);
        updateGlobalCartCount();
        setTimeout(() => {
          btn.innerHTML = originalText;
          btn.style.background = '#1E1E1E';
          btn.disabled = false;
        }, 2000);
      });
    } else if (btn.classList.contains('samdiya-quick-add-btn')) {
      e.preventDefault();
      e.stopPropagation();

      const originalText = btn.innerHTML;
      btn.innerHTML = '✓ Added!';
      btn.style.background = '#3D4F40';
      showToast(`Added "${title}" to your cart!`);
      updateGlobalCartCount();

      setTimeout(() => {
        btn.innerHTML = originalText;
        btn.style.background = '#1E1E1E';
      }, 2000);
    }
  });

/* 2. Product Gallery Slider (Drag-Follow + Thumbnail Sync) */
  const sliderTrack = document.getElementById('samdiya-slider-track');
  const thumbItems = document.querySelectorAll('.samdiya-thumb-item');
  const mainStage = document.querySelector('.samdiya-main-media-stage');

  if (sliderTrack && thumbItems.length > 0) {
    let currentIndex = 0;
    let stageWidth = mainStage.offsetWidth;
    let startX = 0;
    let startY = 0;
    let currentTranslate = 0;
    let dragging = false;
    /* 2026-09-11 mobile fix: this handler had no axis lock, unlike the
       category/collection carousels elsewhere in the theme (see
       sections/samdiya-explore-categories.liquid and
       sections/samdiya-featured-collection.liquid), and both touch listeners
       were `{ passive: true }` with no preventDefault. That meant ANY finger
       movement while touching the main product image — including the
       incidental horizontal jitter in a swipe that was really just meant to
       scroll the page down past the image — dragged the gallery sideways at
       the same time the page scrolled vertically, a jarring double-motion
       and a source of accidental slide changes. axisLocked mirrors the
       established pattern: the first ~6px of movement decides whether this
       gesture is a horizontal swipe (lock it, prevent default, drag the
       slide) or a vertical one (leave it alone so the page scrolls
       normally). */
    let axisLocked = null;

    function goToSlide(index, animate) {
      index = Math.max(0, Math.min(index, thumbItems.length - 1));
      currentIndex = index;
      stageWidth = mainStage.offsetWidth;
      sliderTrack.style.transition = animate ? 'transform 0.3s ease' : 'none';
      sliderTrack.style.transform = `translateX(-${currentIndex * stageWidth}px)`;

      thumbItems.forEach((t, i) => t.classList.toggle('active', i === index));
      thumbItems[index].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }

    thumbItems.forEach((thumb, index) => {
      thumb.addEventListener('click', function () {
        goToSlide(index, true);
      });
    });

    mainStage.addEventListener('touchstart', function (e) {
      dragging = true;
      axisLocked = null;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      stageWidth = mainStage.offsetWidth;
      sliderTrack.style.transition = 'none';
    }, { passive: true });

    mainStage.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      const deltaX = e.touches[0].clientX - startX;
      const deltaY = e.touches[0].clientY - startY;

      if (axisLocked === null && (Math.abs(deltaX) > 6 || Math.abs(deltaY) > 6)) {
        axisLocked = Math.abs(deltaX) > Math.abs(deltaY);
      }
      if (!axisLocked) return; // vertical intent — let the page scroll, don't drag the slide

      e.preventDefault();
      currentTranslate = -(currentIndex * stageWidth) + deltaX;
      sliderTrack.style.transform = `translateX(${currentTranslate}px)`;
    }, { passive: false });

    mainStage.addEventListener('touchend', function (e) {
      if (!dragging) return;
      dragging = false;
      if (!axisLocked) return;
      const deltaX = e.changedTouches[0].clientX - startX;
      const threshold = stageWidth * 0.2;

      if (deltaX < -threshold && currentIndex < thumbItems.length - 1) {
        goToSlide(currentIndex + 1, true);
      } else if (deltaX > threshold && currentIndex > 0) {
        goToSlide(currentIndex - 1, true);
      } else {
        goToSlide(currentIndex, true);
      }
      axisLocked = null;
    });

  window.addEventListener('resize', function () {
      goToSlide(currentIndex, false);
    });

    goToSlide(0, false);

    // Re-sync position once everything (images, fonts, layout) has fully loaded
    window.addEventListener('load', function () {
      goToSlide(currentIndex, false);
    });

    // Also re-sync shortly after in case images load async/lazily
    setTimeout(function () {
      goToSlide(currentIndex, false);
    }, 300);
  }

  /* 3. Variant Swatches Selection */
  const swatchButtons = document.querySelectorAll('.samdiya-swatch-btn');
  swatchButtons.forEach(btn => {
    btn.addEventListener('click', function () {
      const parent = btn.closest('.samdiya-option-group');
      if (parent) {
        parent.querySelectorAll('.samdiya-swatch-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const val = btn.getAttribute('data-val');
        const label = parent.querySelector('strong');
        if (label && val) {
          label.textContent = val;
        }
      }
    });
  });

  /* 4. Copy Coupon Code Buttons */
  const copyButtons = document.querySelectorAll('.samdiya-copy-coupon');
  copyButtons.forEach(btn => {
    btn.addEventListener('click', function () {
      const code = btn.getAttribute('data-code');
      if (code) {
        navigator.clipboard.writeText(code).then(() => {
          const originalText = btn.textContent;
          btn.textContent = '✓ Copied!';
          btn.style.background = '#4A5D4E';
          btn.style.color = '#FFF';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.style.background = '#FFF';
            btn.style.color = 'var(--samdiya-charcoal)';
          }, 2000);
        });
      }
    });
  });

  /* 5. Product Collapsible Accordions Drawer */
  const accordionHeaders = document.querySelectorAll('.samdiya-accordion-header');
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function () {
      const parent = header.parentElement;
      parent.classList.toggle('active');
    });
  });

  /* 6. Quantity Stepper */
  const qtyInput = document.getElementById('samdiya-qty-input');
  const minusBtn = document.getElementById('samdiya-qty-minus');
  const plusBtn = document.getElementById('samdiya-qty-plus');

  if (qtyInput && minusBtn && plusBtn) {
    minusBtn.addEventListener('click', function () {
      let current = parseInt(qtyInput.value) || 1;
      if (current > 1) {
        qtyInput.value = current - 1;
      }
    });

    plusBtn.addEventListener('click', function () {
      let current = parseInt(qtyInput.value) || 1;
      qtyInput.value = current + 1;
    });
  }

  /* 7. Pincode Delivery Estimator Check */
  const pincodeBtn = document.getElementById('samdiya-check-pincode');
  const pincodeInput = document.getElementById('samdiya-pincode-input');
  const pincodeResult = document.getElementById('samdiya-pincode-result');

  if (pincodeBtn && pincodeInput && pincodeResult) {
    pincodeBtn.addEventListener('click', function () {
      const val = pincodeInput.value.trim();
      const isValidPincode = /^[1-9][0-9]{5}$/.test(val);

      if (isValidPincode) {
        pincodeResult.style.display = 'block';
        pincodeResult.innerHTML = `<span style="color:#4A5D4E; font-weight:600;">✓ We deliver to ${val}</span><br><span style="color:#555;">Estimated delivery: <strong>4–7 business days</strong> via Shiprocket. Cash on Delivery availability is confirmed at checkout for your exact address.</span>`;
      } else {
        pincodeResult.style.display = 'block';
        pincodeResult.innerHTML = `<span style="color:#D9534F;">Please enter a valid 6-digit Indian Pincode.</span>`;
      }
    });
  }

  /* 8+11+12+13. Consolidated scroll engine (fixed 2026-09-06 — mobile lag/jank fix)
     Previously these were 4 separate `window.addEventListener('scroll', ...)` handlers,
     three of them completely unthrottled (header background, back-to-top button,
     scrollspy). The scrollspy handler in particular re-read `offsetTop`/`clientHeight`
     from EVERY tracked section on EVERY scroll event — a forced synchronous layout
     read on every scroll tick, i.e. layout thrashing. On a long page with lots of
     sections this is disproportionately expensive on mid/low-end mobile CPUs and is
     a real contributor to reported "random" mobile lag/jank.

     Fixed by: (a) merging all scroll-driven DOM writes into a single
     requestAnimationFrame-batched tick per frame instead of 3-4 independent handlers,
     and (b) caching each scrollspy section's offsetTop ONCE (recomputed only on
     resize/load) instead of reading layout on every scroll event. Visual behavior
     (header background swap, back-to-top visibility, parallax, active nav link) is
     unchanged — only the cost of computing it every frame is reduced. */
  const scrollContainer = document.querySelector('.page-wrapper') || window;
  const headerElem = document.querySelector('header');
  const heroMedia = document.querySelector('.samdiya-hero-media img, .samdiya-hero');
  /* 2026-09-18: Replaced the floating "Back to Top" button with a floating WhatsApp
     chat button per merchant request. Clicking it opens a WhatsApp chat with the
     store's number and a pre-filled greeting message in the customer's message box.
     Left as an always-visible <a> (no scroll-triggered show/hide) since a contact
     button should be reachable from anywhere on the page, not just after scrolling. */
  const whatsappNumber = '919664973788';
  const whatsappMessage = "Hi SAMDIYA! I'd love to know more about your products. Could you help me?";
  const whatsappBtnEl = (function () {
    let link = document.getElementById('samdiya-whatsapp-button');
    if (!link) {
      link = document.createElement('a');
      link.id = 'samdiya-whatsapp-button';
      link.href = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.setAttribute('aria-label', 'Chat with us on WhatsApp');
      link.innerHTML = `<svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true"><path d="M16.004 3C9.377 3 4 8.373 4 15c0 2.31.653 4.468 1.786 6.303L4 29l7.86-1.748A11.94 11.94 0 0 0 16.004 27C22.63 27 28 21.627 28 15S22.63 3 16.004 3Zm0 21.75a9.7 9.7 0 0 1-4.94-1.353l-.354-.21-4.664 1.037 1.02-4.548-.232-.372A9.69 9.69 0 0 1 5.25 15c0-5.93 4.824-10.75 10.754-10.75S26.75 9.07 26.75 15 21.934 24.75 16.004 24.75Zm5.62-7.66c-.308-.154-1.82-.898-2.102-1-.282-.103-.487-.154-.692.154-.205.308-.795 1-.975 1.205-.18.205-.36.23-.667.077-.308-.154-1.3-.48-2.476-1.53-.916-.817-1.535-1.826-1.715-2.134-.18-.308-.02-.474.135-.627.138-.138.308-.36.462-.54.154-.18.205-.308.308-.513.103-.205.051-.385-.026-.539-.077-.154-.692-1.667-.948-2.283-.25-.6-.503-.519-.692-.529-.18-.009-.385-.011-.59-.011-.205 0-.539.077-.821.385-.282.308-1.077 1.052-1.077 2.565s1.103 2.975 1.257 3.18c.154.205 2.17 3.313 5.257 4.646.735.317 1.308.507 1.755.649.737.234 1.408.201 1.938.122.591-.088 1.82-.744 2.077-1.462.257-.718.257-1.334.18-1.462-.077-.128-.282-.205-.59-.36Z"/></svg>`;
      document.body.appendChild(link);
    }
    return link;
  })();

  const scrollspySections = document.querySelectorAll('section, .samdiya-section');
  const scrollspyNavLinks = document.querySelectorAll('.samdiya-nav-links-list a');
  const hasScrollspy = scrollspySections.length > 0 && scrollspyNavLinks.length > 0;

  // Cache each section's top offset once, instead of reading layout on every scroll tick.
  let scrollspyOffsets = [];
  function recomputeScrollspyOffsets() {
    if (!hasScrollspy) return;
    scrollspyOffsets = Array.prototype.map.call(scrollspySections, function (sec) {
      return {
        id: sec.getAttribute('id') || '',
        top: sec.offsetTop - 120,
        height: sec.offsetHeight
      };
    });
  }
  recomputeScrollspyOffsets();

  let scrollTicking = false;
  function onScrollFrame() {
    const scrollY = scrollContainer === window ? window.scrollY : scrollContainer.scrollTop;

    // Header background swap
    if (headerElem) {
      if (scrollY > 40) {
        headerElem.style.background = 'rgba(250, 247, 242, 0.98)';
        headerElem.style.boxShadow = '0 4px 20px rgba(0,0,0,0.06)';
      } else {
        headerElem.style.background = 'rgba(250, 247, 242, 0.94)';
        headerElem.style.boxShadow = 'none';
      }
    }

    // Hero parallax
    if (heroMedia && scrollY < 800) {
      heroMedia.style.transform = `translate3d(0, ${scrollY * 0.12}px, 0)`;
    }

    // Scrollspy — uses cached offsets, no layout read here
    if (hasScrollspy) {
      let currentSecId = '';
      for (let i = 0; i < scrollspyOffsets.length; i++) {
        const entry = scrollspyOffsets[i];
        if (scrollY >= entry.top && scrollY < entry.top + entry.height) {
          currentSecId = entry.id;
          break;
        }
      }
      if (currentSecId) {
        scrollspyNavLinks.forEach(function (link) {
          const href = link.getAttribute('href');
          link.classList.toggle('active', !!(href && href.includes(currentSecId)));
        });
      }
    }

    scrollTicking = false;
  }

  scrollContainer.addEventListener('scroll', function () {
    if (!scrollTicking) {
      window.requestAnimationFrame(onScrollFrame);
      scrollTicking = true;
    }
  }, { passive: true });

  window.addEventListener('resize', recomputeScrollspyOffsets);
  window.addEventListener('load', recomputeScrollspyOffsets);

  // Run once on init so header/back-to-top/scrollspy reflect the initial scroll position
  onScrollFrame();

  /* 9. Concept / Inova Style Staggered Scroll-Triggered Reveal Engine (tuned down 2026-09-01 for a snappier, less "buffering" feel — see samdiya-custom.css for the matching duration/delay reductions) */
  const sectionsToObserve = document.querySelectorAll('.samdiya-section, footer, .samdiya-marquee-section');
  sectionsToObserve.forEach(sec => {
    sec.classList.add('samdiya-scroll-reveal');
    const cards = sec.querySelectorAll('.samdiya-card, .samdiya-space-card, .samdiya-circle-category-item, product-card');
    cards.forEach((card, idx) => {
      card.classList.add('samdiya-scroll-reveal');
      card.classList.add(`samdiya-delay-${(idx % 5) + 1}`);
    });
  });

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, { threshold: 0.05, rootMargin: '0px 0px 80px 0px' });

  document.querySelectorAll('.samdiya-scroll-reveal, .samdiya-scroll-scale').forEach(el => revealObserver.observe(el));

  /* 10. Progressive Blur-to-Clear Image Loader */
  const lazyImages = document.querySelectorAll('img[loading="lazy"]');
  lazyImages.forEach(img => {
    img.classList.add('samdiya-lazy-load');
    if (img.complete) {
      img.classList.add('samdiya-lazy-loaded');
    } else {
      img.addEventListener('load', () => img.classList.add('samdiya-lazy-loaded'));
    }
  });

});
